export const ADMIN = ["administrator"];

export const MANAGERS = [
  "operations_manager",
  "account_manager",
  "project_manager",
  "sales_manager",
  "vendor_manager",
  "finance_manager",
  "accountant",
  "office_admin",
  "language_quality_manager",
  "language_lead",
];

export const ADMIN_AND_MANAGERS = [...ADMIN, ...MANAGERS];

// Vendor manager portal — manages vendor records only (vendors, applications,
// contacts, prices, tags). Distinct from the external `vendor` role.
export const VENDOR_MANAGER = ["vendor_manager"];

// Project manager portal — projects/jobs (scoped to accessible clients),
// clients (scoped to client pool), full system values, read-only vendors.
export const PROJECT_MANAGER = ["project_manager"];

// Admin + project managers: modules a project manager gets full CRUD on but
// other managers do not (system values).
export const ADMIN_AND_PROJECT_MANAGER = [...ADMIN, "project_manager"];

// Admin + managers EXCEPT project managers: modules a project manager may not
// reach at all (client pools, vendor applications, vendor creation).
export const ADMIN_AND_MANAGERS_NO_PM = ADMIN_AND_MANAGERS.filter(
  (r) => r !== "project_manager"
);

export const VENDOR = ["vendor"];

export const CLIENT = ["client"];

// Accessible to admin, managers, AND vendors (e.g. the /jobs page)
export const ALL_STAFF = [...ADMIN_AND_MANAGERS, ...VENDOR];
